import { render } from "./TravelTopics.vue?vue&type=template&id=32b9fc5c&scoped=true"
import script from "./TravelTopics.vue?vue&type=script&lang=js"
export * from "./TravelTopics.vue?vue&type=script&lang=js"

import "./TravelTopics.vue?vue&type=style&index=0&id=32b9fc5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b9fc5c"]])

export default __exports__